import axios from 'axios';
import { getBaseUrl } from "./utils";
export var fetchTariffsByColor = function fetchTariffsByColor(params) {
  return axios.get(getBaseUrl(), {
    params: params
  }).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};